const DIGIT_RE = /\d/g;

/**
 * Format a phone number input based on the country code
 * @param {string} viewValue
 * @param {"USA" | "CAN" | string} countryCode provided by the vm.countryCode.code, @type {string} defaults to european country
 * @param {string} countryCodeValue provided by the vm.countryCode.value, @type {string} ex: "1" for USA and CAN, "61" for AUS, etc defaults ""
 * @returns {string} formatted phone number, removed spaces and sliced to max size depending on country code
 */
export function limitPhoneNumberLengthForInput(viewValue: string, countryCode: "USA" | "CAN" | string, countryCodeValue: string): string {
    const maxNumbers = countryCode === "USA" ? 10
        : countryCode === "CAN" ? 10
            : 15 - countryCodeValue.length; // International numbers per E.164
    const sliceMax = maxNumbers + viewValue.replace(DIGIT_RE, '').length
    return typeof viewValue === 'string'
        ? viewValue.slice(0, sliceMax)
        : '';
}

export function formatPhoneNumberForInput(viewValue: string, countryCode: "USA" | "CAN" | string) {
    const isUSAorCAN = countryCode === "USA" || countryCode === "CAN";
    if (isUSAorCAN) viewValue = viewValue.replace(/^(\D*)[01]+/, '$1');
    return isUSAorCAN ? formatPhoneNumber(viewValue.replace(/\D/g, '')) : viewValue
}

export function formatPhoneNumber(tel) {
    if (!tel) {
        return ''
    }

    let value = tel.toString().trim().replace(/^\+/, '');

    if (value.match(/[^0-9]/)) {
        return tel;
    }

    let area, number;
    switch (value.length) {
        case 1:
        case 2:
        case 3:
            area = value;
            break;
        default:
            area = value.slice(0, 3);
            number = value.slice(3);
    }

    if (number) {
        if (number.length > 3) {
            number = number.slice(0, 3) + '-' + number.slice(3, 7);
        }

        return ("(" + area + ") " + number).trim();
    } else {
        return area;
    }
}
